// See also: src/components/RoutesComponents.tsx

import { encodeTag, encodeTags } from "utils/strings";

const search = (query: string, sort: string = "", type: string = "") => (
  `/browse/${query}${sort || type ? "?" : ""}${sort ? `sort=${sort}` : ""}${type ? `${sort ? "&" : ""}type=${type}` : ""}`
);

const constructQueryParams = (order?: string, verified?: boolean) => {
  const queryParams = new URLSearchParams();

  if (order) {
    queryParams.append("order", order);
  }

  if (verified) {
    queryParams.append("verified", "1");
  }

  return queryParams.toString().length ? `?${queryParams.toString()}` : "";
};

export const routes = {
  accountSettings: () => "/settings/account",
  collection: (userId: string, id: string) => `/users/${userId}/collections/${id}`,
  crash: () => "/crash",
  create: () => "/create",
  dmca: () => "/dmca",
  embed: (id: string) => `/ifr/${id}`,
  explore: () => "/explore",
  exploreCreators: (order?: string, verified?: boolean) => `/creators${constructQueryParams(order, verified)}`,
  exploreImages: (order?: string, verified?: boolean) => `/explore/images${constructQueryParams(order, verified)}`,
  exploreTop: (order?: string, verified?: boolean) => `/explore/top${constructQueryParams(order, verified)}`,
  favourites: () => "/gifs/favourites",
  faq: () => "/faq",
  following: () => "/following",
  followers: () => "/followers",
  guidelines: () => "/guidelines",
  home: (videoId?: string) => `/${videoId ? (`?video=${videoId}`) : ""}`,
  login: () => "/login",
  manageProfile: () => "/profile/manage",
  myNiches: () => "/niches/my",
  niche: (id: string, order?: string) => `/niches/${id}${constructQueryParams(order)}`,
  niches: () => "/niches",
  privacyPolicy: () => "/privacy",
  profileSettings: () => "/settings/profile",
  search: search,
  signup: () => "/signup",
  singleTag: (tag: string, order?: string, verified?: boolean) => `/gifs/${encodeTag(tag)}${constructQueryParams(order, verified)}`,
  multipleTag: (tags: string[], order?: string, verified?: boolean) => `/gifs/${encodeTags(tags)}${constructQueryParams(order, verified)}`,
  statement2257: () => "/notice2257",
  terms: () => "/terms",
  trendingTags: () => "/categories",
  trendingTagsA: (a: string) => `/categories/${a}`,
  unsubscribed: () => "/unsubscribed",
  user: (id: string, order?: string) => `/users/${id}${constructQueryParams(order)}`,
  userCollections: (userId: string) => `/users/${userId}/collections`,
  verify: () => "/user/verify",
  watch: (id: string, rel?: string, source?: string, order?: string, verified?: boolean) => {
    const relPart = rel ? `#rel=${encodeURIComponent(rel)}` : "";
    const sourcePart = source ? `?source=${source}` : "";
    const orderPart = order ? `;order=${order}` : "";
    const verifiedPart = verified ? `;verified=${verified}` : "";
    const resultPart = relPart ? `${relPart}${orderPart}${verifiedPart}` : `${sourcePart}`;

    return `/watch/${id}${resultPart}`;
  }
};
